import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceAreas from "@/pages/ServiceAreas";
import CityPage from "@/pages/CityPage";
import About from "@/pages/About";
import Quote from "@/pages/Quote";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import LogoPreview from "@/pages/LogoPreview";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<><ScrollToTop /><Home /></>} />
            <Route path="/services" element={<><ScrollToTop /><Services /></>} />
            <Route path="/service-areas" element={<><ScrollToTop /><ServiceAreas /></>} />
            <Route path="/service-areas/:slug" element={<><ScrollToTop /><CityPage /></>} />
            <Route path="/about" element={<><ScrollToTop /><About /></>} />
            <Route path="/quote" element={<><ScrollToTop /><Quote /></>} />
            <Route path="/blog" element={<><ScrollToTop /><Blog /></>} />
            <Route path="/blog/:slug" element={<><ScrollToTop /><BlogPost /></>} />
            <Route path="/faq" element={<><ScrollToTop /><FAQ /></>} />
            <Route path="/admin/logos" element={<><ScrollToTop /><LogoPreview /></>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
